export var ProductPricingAdaptor = function(productPricing) {
    var pricing = productPricing;

    var StockData = function(lineItemDetails) {
        var details = lineItemDetails;

        this.isAtpRequired = function() {
            return details.atpRequired;
        };

        this.getAvailableQuantity = function() {
            return details.availableQuantity;
        };

        this.isBackOrdered = function() {
            return details.backOrdered;
        };

        this.isInvalidSku = function() {
            return details.invalidSku;
        };

        this.getTotalAvailableQty = function() {
            return details.totalAvailableQuantity;
        };
    };

    this.getSku = function() {
        return pricing.code;
    };

    this.getAdrPrice = function() {
        return pricing.adrPrice.formattedValue;
    };

    this.getAdrPvValue = function() {
        return pricing.adrPvValue.formattedValue;
    };

    this.getPrice = function() {
        return pricing.price.formattedValue;
    };

    this.getPvValue = function() {
        return pricing.pvValue.formattedValue;
    };

    this.getRetailStatus = function() {
        return pricing.retailStatus;
    };

    this.getWholeSaleStatus = function() {
        return pricing.wholeSaleStatus;
    };

    this.getStockData = function() {
        var details = [];

        for (var i=0; i<pricing.stockData.lineItemDetailsList.length; i++) {
            details.push(new StockData(pricing.stockData.lineItemDetailsList[i]));
        }
    };

    // todo Set the stock data as part of the contruction process. Don't set it on the read.
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/productPricing/ProductPricingAdaptor.js
// module id = 280
// module chunks = 0